import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormulaBlueComponent } from './formula-blue/formula-blue.component';
import { ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { I18nModule, FeaturesConfigModule, UrlModule, CmsConfig, ConfigModule, AuthGuard } from '@spartacus/core';
import { AtMessageModule, IconModule, ItemCounterModule, ListNavigationModule, MediaModule, OutletModule, PageComponentModule, SpinnerModule, StarRatingModule, ProductListModule } from '@spartacus/storefront';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { FacetNavigationModule } from '../facet-navigation/facet-navigation.module';
import { KbDocumentGridItemModule } from '../kb-product-list/kb-document-grid/kb-document-grid.module';
import { KbDocumentListItemModule } from '../kb-product-list/kb-document-list/kb-document-list.module';
import { KbProductGridItemModule } from '../kb-product-list/kb-product-grid-item/kb-product-grid-item.module';
import { KbProductListItemModule } from '../kb-product-list/kb-product-list-item/kb-product-list-item.module';
import { SecureGuard } from 'src/app/services/Guards/secure.service';
import { KbPaginationModule } from '../kb-pagination/kb-pagination/kb-pagination.module';



@NgModule({
  declarations: [
    FormulaBlueComponent
  ],
  imports: [
    CommonModule,
    I18nModule,
    ReactiveFormsModule,
    AtMessageModule,
    FeaturesConfigModule,
    IconModule,
    InfiniteScrollModule,
    ItemCounterModule,
    ListNavigationModule,
    MediaModule,
    OutletModule,
    PageComponentModule,
    RouterModule,
    SpinnerModule,
    StarRatingModule,
    UrlModule,
    ProductListModule,
    KbDocumentGridItemModule,
    KbDocumentListItemModule,
    FacetNavigationModule,
    KbProductGridItemModule,
    KbProductListItemModule,
    KbPaginationModule,

    ConfigModule.withConfig({
      cmsComponents: {
        FormulaBlueSearchFlexComponent: {
          component: FormulaBlueComponent,
          guards: [SecureGuard]
        }
      }
    } as CmsConfig)
  ]
})
export class KbFormulaBlueModule { }
